import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import KanbanEnterpriseColumn from "./KanbanEnterpriseColumn";
import KanbanCardPreview from "./KanbanCardPreview";

const useStyles = makeStyles((theme) => ({
  board: {
    display: "flex",
    gap: theme.spacing(1.5),
    flex: 1,
    minHeight: 0,
    overflowX: "auto",
    overflowY: "hidden",
    padding: theme.spacing(0.5),
    "&::-webkit-scrollbar": { height: 6 },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(128,128,128,0.3)",
      borderRadius: 4,
    },
  },
  lanesRow: {
    display: "flex",
    gap: 12,
    flex: 1,
    minWidth: 0,
  },
}));

const KanbanEnterpriseBoard = ({
  inboxColumn = null,
  columns = [],
  columnTickets = {},
  columnCounts = {},
  columnHasMore = {},
  columnLoading = {},
  onLoadMore,
  onDragEnd,
  onEditColumn,
  onColumnRename,
  onQuickAction,
  isAdmin = false,
  viewMode = "comfortable",
  cardStyle = "rich",
}) => {
  const classes = useStyles();
  const [previewTicket, setPreviewTicket] = useState(null);
  const [previewAnchor, setPreviewAnchor] = useState(null);

  const handleHoverCard = useCallback((ticket, el) => {
    setPreviewTicket(ticket);
    setPreviewAnchor(el);
  }, []);

  const handleLeaveCard = useCallback(() => {
    setPreviewTicket(null);
    setPreviewAnchor(null);
  }, []);

  const columnProps = (col, dragHandleProps = null, adminFlag = isAdmin) => ({
    column: col,
    tickets: columnTickets[col.id] || [],
    count: columnCounts[col.id] || 0,
    hasMore: columnHasMore[col.id] || false,
    loading: columnLoading[col.id] || false,
    onLoadMore,
    onEditColumn: col.isVirtual ? undefined : onEditColumn,
    onColumnRename: col.isVirtual ? undefined : onColumnRename,
    onHoverCard: handleHoverCard,
    onLeaveCard: handleLeaveCard,
    onQuickAction,
    dragHandleProps,
    isAdmin: col.isVirtual ? false : adminFlag,
    viewMode,
    cardStyle,
  });

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className={classes.board}>
          {/* Inbox fixo à esquerda — não participa do reorder de lanes */}
          {inboxColumn && (
            <div style={{ flexShrink: 0 }}>
              <KanbanEnterpriseColumn {...columnProps(inboxColumn)} />
            </div>
          )}

          <Droppable droppableId="board" direction="horizontal" type="LANE">
            {(boardProvided) => (
              <div
                ref={boardProvided.innerRef}
                {...boardProvided.droppableProps}
                className={classes.lanesRow}
              >
                {columns.map((col, index) => (
                  <Draggable
                    key={col.id}
                    draggableId={`lane-${col.id}`}
                    index={index}
                    isDragDisabled={!isAdmin}
                  >
                    {(dragProvided, dragSnapshot) => (
                      <div
                        ref={dragProvided.innerRef}
                        {...dragProvided.draggableProps}
                        style={{
                          ...dragProvided.draggableProps.style,
                          opacity: dragSnapshot.isDragging ? 0.85 : 1,
                        }}
                      >
                        <KanbanEnterpriseColumn
                          {...columnProps(col, dragProvided.dragHandleProps)}
                        />
                      </div>
                    )}
                  </Draggable>
                ))}
                {boardProvided.placeholder}
              </div>
            )}
          </Droppable>
        </div>
      </DragDropContext>

      <KanbanCardPreview
        ticket={previewTicket}
        anchorEl={previewAnchor}
        onClose={handleLeaveCard}
      />
    </>
  );
};

export default KanbanEnterpriseBoard;
